import React, { useState, useLayoutEffect } from "react";
import Layout from "../components/layout";
import { graphql, Script } from "gatsby";
import parse from "html-react-parser";
import MarketoForm from "../components/marketo";

//export { Head } from "../components/head";
export const Head = ({ pageContext }) => {
  return (
    <>
      <link
        rel="alternate"
        href={`https://www.lacework.com${pageContext.slug}`}
        hreflang="en"
      />
      <link
        rel="alternate"
        href={`https://www.lacework.com/fr${pageContext.slug}`}
        hreflang="fr"
      />
      <link
        rel="alternate"
        href={`https://www.lacework.com/de${pageContext.slug}`}
        hreflang="de"
      />
      <meta
        name="robots"
        content={`${pageContext?.metaRobotsNoindex ?? "index"},${
          pageContext?.metaRobotsNofollow ?? "follow"
        }`}
      />

      {parse(
        pageContext?.fullHead.replaceAll(
          `${process.env.GATSBY_WP_BASE_PAGES}`,
          `${process.env.GATSBY_LW_BASE_URL}`
        )
      )}
    </>
  );
};
const options = {
  replace: (domNode, index) => {
    const formId = domNode?.attribs?.["data-form-id"];
    const thankyouHeading = domNode?.attribs?.["data-thank-you-heading"];
    const thankyouButtonText = domNode?.attribs?.["data-thank-you-button-text"];
    const resourceURL = domNode?.attribs?.["data-resource-url"];
    if (formId && resourceURL) {
      return (
        <MarketoForm
          formId={formId}
          thankyouHeading={thankyouHeading}
          thankyouButtonText={thankyouButtonText}
          resourceURL={resourceURL}
        />
      );
    }

    if (domNode.type === "script") {
      return (
        <Script key={index} {...domNode.attribs}>
          {domNode.children?.length && domNode.children[0].data}
        </Script>
      );
    }

    if (domNode?.name === "img" && domNode?.attribs?.src) {
      const src = domNode?.attribs?.src;
      if (src.startsWith("/")) {
        // Tmp fix for images GATSBY_GATSBY_WP_BASE_PAGES is not defined in netlify env variables not sure if it needs to be different
        domNode.attribs.src = `${process.env.GATSBY_WP_BASE_PAGES}${src}`;
        // domNode.attribs.src = `${process.env.GATSBY_GATSBY_WP_BASE_PAGES}${src}`;
      } else if (src.startsWith("http://")) {
        // replace http:// with https://
        domNode.attribs.src = src.replace("http://", "https://");
      }
    }
    return domNode;
  },
};

export default function Resource({ data }) {
  const post = data ? data.wpPages.resource : null;
  const renderedContent = post ? post.renderedContent : null;
  const themeRegex = renderedContent.match(/data-theme=.*"(.*?)"/);
  const theme = themeRegex ? themeRegex[1] : "dark";
  const dark = theme === "dark" ? true : false;
  const parsedContent = renderedContent
    ? parse(renderedContent, options)
    : null;

  if (!parsedContent) return;

  return (
    <React.Fragment>
      <Layout dark={dark}>{parsedContent}</Layout>
    </React.Fragment>
  );
}

export const query = graphql`
  query ($slug: ID!) {
    wpPages {
      resource(id: $slug, idType: URI) {
        title
        renderedContent
      }
    }
  }
`;
